import { render, staticRenderFns } from "./UiListDataProgress.vue?vue&type=template&id=54ec6f34"
import script from "./UiListDataProgress.vue?vue&type=script&lang=js"
export * from "./UiListDataProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports